import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import { Box } from '@chatterbug/aaron'
import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'
import RateActivity from 'src/ui/RateActivity/RateActivity'

export const QUESTIONS = {
  reading: t('How comfortable were you with this reading?'),
  video: t('How comfortable were you with this video?'),
  audio: t('How comfortable were you with this audio?'),
}

const WrapupCardRateActivity = ({ activityType, onActivityRated }) => {
  const question = QUESTIONS[activityType]
  const legendId = `rate-activity-legend-${Math.random()}`

  if (!question) {
    return null
  }
  return (
    <PageWrapupCard>
      <Box
        variant="text.h4"
        lineHeight={1.2}
        textAlign="center"
        mb="4x"
        id={legendId}
      >
        {question}
      </Box>
      <RateActivity onChange={onActivityRated} ariaLabelledby={legendId} />
    </PageWrapupCard>
  )
}

WrapupCardRateActivity.propTypes = {
  activityType: PropTypes.oneOf(['reading', 'video', 'audio']).isRequired,
  onActivityRated: PropTypes.func,
}

export default WrapupCardRateActivity
